<section id="comman-baaner"></section>
<div class="container-fluid paddEqual">
    <div class="container">
        <div class="row">
            <div class="col-md-10 offset-md-1">
                <div class="wrap-forgotP" *ngIf="forgotForm">
                    <div class="col-md-6 text-center">
                        <img src="assets/images/forgot-password.png" alt="Forgot" class="img-fluid login100-pic">
                    </div>
                    <div class="col-md-6">
                        <app-matloader *ngIf="loader"></app-matloader>
                        <form class="login100-form forgot100-form" name="forgot_password" id="forgot_password"
                            method="post" (ngSubmit)="sendOtp()" #forgot_password="ngForm" style="position:relative">
                            <span class="login100-form-title">Forgot your password?</span> 
                            <p style="font-size: 14px;color:#ee8d06;font-weight:300;text-align:center" *ngIf="errorMsg">
                                <i class="fa fa-warning" aria-hidden="true"></i>&nbsp;<span
                                    [innerHTML]="errorMsg"></span></p>
                            <p style="font-size: 14px;color:green;font-weight:300;text-align:center" *ngIf="successMsg">
                                <i class="fa fa-check" aria-hidden="true"></i>&nbsp;<span
                                    [innerHTML]="successMsg"></span></p>
                            <span class="loginMsg"></span>
                            <div class="wrap-input100">
                                <label class="text-center">Don't worry. Resetting your password is easy, just tell us
                                    the mobile number you registered with Propira.</label>
                            </div>
                            <div class="row" style="margin: 0;">
                                <div class="wrap-input100 col-md-5" style="padding: 0;">
                                    <select class="input100" type="text" name="phone_type" placeholder="IND +91"
                                        style="padding: 0 0 0 20px" id="phone_type" #phone_type="ngModel"
                                        [(ngModel)]="forgot.phone_type">
                                        <option [selected]="forgot.mobile=='91'" value="91">IND +91</option>
                                    </select>
                                    <span class="focus-input100"></span>
                                </div>
                                <div class="wrap-input100 col-md-7" style="padding: 0;">
                                    <input class="input100" type="tel" pattern="^\d{10}$" name="mobile" maxLength="10"
                                        (keypress)="numberOnly($event)" required placeholder="Mobile Number" id="mobile" autofocus
                                        #mobile="ngModel" [(ngModel)]="forgot.mobile">
                                    <span class="focus-input100"></span>
                                    <span class="symbol-input100">
                                        <i class="fa fa-mobile" aria-hidden="true"></i>
                                    </span>
                                </div>
                                <div *ngIf="mobile.invalid && (mobile.dirty || mobile.touched)" class="text-danger">
                                    <p *ngIf="mobile.errors.required">Mobile is required.</p>
                                    <p *ngIf="mobile.errors.pattern">Enter valid Mobile No.</p>
                                </div>
                            </div>
                            <div class="container-login100-form-btn">
                                <button class="login100-form-btn" [disabled]="!forgot_password.form.valid"
                                    type="submit">Submit</button>
                            </div>
                            <div class="text-center p-t-12">
                                <a class="txt2" style="cursor:pointer" data-toggle="modal" data-target="#loginModal">Signup/Login ? </a>
                            </div>
                        </form>
                    </div>
                </div> 
                <!--verify otp-->
                <div class="wrap-forgotP" *ngIf="verifyForm">
                    <div class="col-md-6 text-center">
                        <img src="assets/images/verify-otp.png" alt="verify" class="img-fluid login100-pic">
                    </div>
                    <div class="col-md-6">
                        <form class="login100-form forgot100-form" name="verify_form" id="verify_form" method="post"
                            (ngSubmit)="verfiyOtp()" #verify_form="ngForm" style="position:relative">
                            <app-matloader *ngIf="loader"></app-matloader>
                            <span class="login100-form-title">Verify</span>
                            <p style="font-size: 14px;color:#ee8d06;font-weight:300;text-align:center" *ngIf="errorMsg">
                                <i class="fa fa-warning" aria-hidden="true"></i>&nbsp;<span
                                    [innerHTML]="errorMsg"></span></p>
                            <p style="font-size: 14px;color:green;font-weight:300;text-align:center" *ngIf="successMsg">
                                <i class="fa fa-check" aria-hidden="true"></i>&nbsp;<span
                                    [innerHTML]="successMsg"></span></p>
                            <span class="loginMsg"></span>
                            <div class="wrap-input100">
                                <label class="text-center">OTP has been sent to your mobile XXXXXX{{showmobile}}, please
                                    enter same here to verify.</label>
                            </div>
                            <div class="row otpVerify" style="margin: 0;">
                                <div class="wrap-input100 col-md-4" style="padding: 0;">
                                    <input class="input100 change" type="text" name="pass1" maxlength="1" size="1"  
                                        required id="pass1" [(ngModel)]="forgot.pass1" #pass1="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <div class="wrap-input100 col-md-4" style="padding: 0;">
                                    <input class="input100 change" type="text" name="pass2" maxlength="1" size="1"
                                        required id="pass2" [(ngModel)]="forgot.pass2" #pass2="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <div class="wrap-input100 col-md-4" style="padding: 0;">
                                    <input class="input100 change" type="text" name="pass3" maxlength="1" size="1"
                                        required id="pass3" [(ngModel)]="forgot.pass3" #pass3="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <!-- <div class="wrap-input100 col-md-2" style="padding: 0;">
                                    <input class="input100 change" type="text" name="pass4" maxlength="1" size="1"
                                        required id="pass4" [(ngModel)]="forgot.pass4" #pass4="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <div class="wrap-input100 col-md-2" style="padding: 0;">
                                    <input class="input100 change" type="text" name="pass5" maxlength="1" size="1"
                                        required id="pass5" [(ngModel)]="forgot.pass5" #pass5="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <div class="wrap-input100 col-md-2" style="padding: 0;">
                                    <input class="input100 change" type="text" name="pass6" maxlength="1" size="1"
                                        required id="pass6" [(ngModel)]="forgot.pass6" #pass6="ngModel">
                                    <span class="focus-input100"></span>
                                </div> -->
                            </div>
                            <p class="one_time_password text-danger" (click)="resendOtp()"
                                style="cursor:pointer;margin:0px;margin-top:-5px;font-size: 12px;float:right">RESEND
                                (OTP)</p>
                            <div class="container-login100-form-btn">
                                <button class="login100-form-btn" type="submit"
                                    [disabled]="!verify_form.form.valid">Verify</button>
                            </div>
                        </form>
                    </div>
                </div>

                <!--change password-->


                <div class="wrap-forgotP" *ngIf="passwordForm">
                    <div class="col-md-6 text-center">
                        <img src="assets/images/update-password.png" alt="update" class="img-fluid login100-pic">
                    </div>
                    <div class="col-md-6">
                        <app-matloader *ngIf="loader"></app-matloader>
                        <form class="login100-form forgot100-form" name="change_password" id="changePassword"
                            method="post" (ngSubmit)="updatePassword()" #changePassword="ngForm"
                            style="position:relative">
                            <span class="login100-form-title">Update Password</span>
                            <p style="font-size: 14px;color:#ee8d06;font-weight:300;text-align:center" *ngIf="errorMsg">
                                <i class="fa fa-warning" aria-hidden="true"></i>&nbsp;<span
                                    [innerHTML]="errorMsg"></span></p>
                            <p style="font-size: 14px;color:green;font-weight:300;text-align:center" *ngIf="successMsg">
                                <i class="fa fa-check" aria-hidden="true"></i>&nbsp;<span
                                    [innerHTML]="successMsg"></span></p>
                            <div class="wrap-input100">
                                <input class="input100" type="password" name="password" placeholder="Password"
                                    id="password" required [(ngModel)]="forgot.password" #password="ngModel">
                                <span class="focus-input100"></span>
                                <span class="symbol-input100">
                                    <i class="fa fa-lock" aria-hidden="true"></i>
                                </span>
                            </div>
                            <div class="wrap-input100">
                                <input class="input100" type="password" name="confirm_password" id="confirm_password"
                                    placeholder="Confirm Password" required [(ngModel)]="forgot.confirm_password"
                                    #confirm_password="ngModel">
                                <span class="focus-input100"></span>
                                <span class="symbol-input100">
                                    <i class="fa fa-lock" aria-hidden="true"></i>
                                </span>
                            </div>
                            <div class="container-login100-form-btn">
                                <button class="login100-form-btn" type="submit"
                                    [disabled]="!changePassword.form.valid">Update Password</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>